import BaseScenesPermissions from 'models/Permissions/BaseScenesPermissions'

class EmissionHomePermissions extends BaseScenesPermissions {}

export default EmissionHomePermissions
